import { useEffect, useMemo, useState } from 'react';
import {
  getStoredStoreRequestMessageForUserKeys,
  saveStoredStoreRequestMessageForUserKeys,
} from '../utils/storePickup';

interface UseStoreRequestPreferenceOptions {
  enabled?: boolean;
  storeId: string;
  userId?: string;
}

export const useStoreRequestPreference = ({
  enabled = true,
  storeId,
  userId,
}: UseStoreRequestPreferenceOptions) => {
  const [requestMessage, setRequestMessage] = useState('');

  const cacheUserKeys = useMemo(() => {
    const keys = [userId, 'buyer'];
    return keys.filter(
      (key, index, array): key is string =>
        !!key && array.indexOf(key) === index,
    );
  }, [userId]);

  useEffect(() => {
    if (!enabled || !storeId) {
      setRequestMessage('');
      return;
    }

    const storedRequestMessage = getStoredStoreRequestMessageForUserKeys(
      storeId,
      cacheUserKeys,
    );
    setRequestMessage(storedRequestMessage);
  }, [cacheUserKeys, enabled, storeId]);

  const saveRequestMessage = (message: string) => {
    const nextMessage = message.trim();
    saveStoredStoreRequestMessageForUserKeys(
      storeId,
      nextMessage,
      cacheUserKeys,
    );
    setRequestMessage(nextMessage);
    return nextMessage;
  };

  return {
    requestMessage,
    saveRequestMessage,
  };
};
